import { connect } from "react-redux"

import SearchifySelectField from "app/static/frontend/forms/components/SearchifySelectField"

import { selectReduxFormSearchifySelectFieldValue } from "app/static/frontend/forms/selectors"

const mapStateToProps = (state, props) => ({
    // grab the value from the SelectComponent onChange in the store of ${formKey}
    searchifyValue: selectReduxFormSearchifySelectFieldValue(state, props),
})

const actionCreators = {}

export default connect(mapStateToProps, actionCreators)(SearchifySelectField)
